import { useRef, useState } from 'react';
import Player from 'components/3catinfo/Player';
import LoadingPlayer from 'components/3catinfo/Players/LoadingPlayer';
import clsx from 'clsx';
import styles from './playertts.module.scss';

export default function PlayerTTS(props) {
    const { id, playerVideoTagId, imatges, setMostrarPlayerTTS, mostrarPlayerTTS } = props;
    const [isLoading, setIsLoading] = useState(true);
    const playerRef = useRef();
    const playerControllerInstance = (playerController) => {
        playerController.on('ended', () => {
            playerRef.current.inici();
        });
        playerController.on('ready', () => {
            setTimeout(() => {
                setIsLoading(false);
            }, 150);
        });
    };

    const stylesPlayerTTS = clsx({
        [styles.audio]: true,
        [styles.hidden]: !mostrarPlayerTTS || isLoading
    });
    return (
        <>
            {isLoading && mostrarPlayerTTS && <LoadingPlayer showText={false} fons='fonsContenidorBlanc' />}
            <div className={stylesPlayerTTS}>
                <Player
                    ref={playerRef}
                    playerVideoTagId={`audio-tts-${playerVideoTagId}`}
                    id={id}
                    autoPlay={true}
                    directe={false}
                    tipus='audio_tts'
                    estils='noticia'
                    imatges={imatges}
                    playerControllerInstance={playerControllerInstance}
                    disabledDblClickFullscreen={true}
                ></Player>
            </div>
        </>
    );
}
